export const DEMO_PAYMENT_BYPASS_EMAIL = "paul.icon@gmail.com";

export function isDemoPaymentBypassEmail(email: string | null | undefined): boolean {
  return email?.trim().toLowerCase() === DEMO_PAYMENT_BYPASS_EMAIL;
}
